import {useEffect, useState} from 'react';

const secretCode = 'iddqd';
const editableSelector = 'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="textbox"]';

/** Toggle the app-info Easter egg without intercepting typing in form fields. */
export const useSecretCode = (): boolean => {
    const [unlocked, setUnlocked] = useState(false);

    useEffect(() => {
        let buffer = '';
        const handleKeyDown = (event: KeyboardEvent): void => {
            const {target, key, ctrlKey, altKey, metaKey, isComposing, repeat} = event;
            const editing = target instanceof Element && target.closest(editableSelector);
            if (ctrlKey || altKey || metaKey || isComposing || editing) {
                buffer = '';

                return;
            }
            if (repeat || key === 'Shift') return;
            buffer = key.length === 1 ? `${buffer}${key.toLowerCase()}`.slice(-secretCode.length) : '';
            if (buffer === secretCode) {
                setUnlocked(current => !current);
                buffer = '';
            }
        };
        window.addEventListener('keydown', handleKeyDown);

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return unlocked;
};
